// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mLAW","content":"styles_content__17U2y"};